import React from "react";
import Header from "@/components/landing/Header";
import MissionWorldviewSection from "@/components/landing/MissionWorldviewSection";
import MissionFamilySection from "@/components/landing/MissionFamilySection";
import MissionFutureSection from "@/components/landing/MissionFutureSection";
import NextPageCTA from "@/components/landing/NextPageCTA";
import PageFooter from "@/components/landing/PageFooter";
import RelatedPages from "@/components/landing/RelatedPages";
import { ABOUT_PAGES } from "@/data/navigation";

export default function Mission() {
  return (
    <main className="bg-warm text-graphite min-h-screen">
      <Header />
      <div className="pt-24 md:pt-28" />
      <MissionWorldviewSection />
      <MissionFamilySection />
      <MissionFutureSection />
      <NextPageCTA testId="next-page-cta-mission" />
      <RelatedPages
        pages={ABOUT_PAGES.filter((p) => p.to !== "/misszio")}
        testId="related-pages-mission"
      />
      <PageFooter />
    </main>
  );
}
